import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import {
    commandProvider,
    events,
    on,
    queryProvider,
    serviceCommands,
    serviceQueries
} from '@estee/elc-service-bus';

export const queries = [[serviceQueries.GET_CART, 'getCart']];
export const onEvents = [
    [events.CART_UPDATED, 'showCartOverlay'],
    [events.OFFERS_LOADED, 'onOffersLoaded'],
    [events.CART_OVERLAY_OFFER_CLICKED, 'onOfferCodeApplied'],
    [events.CART_OVERLAY_ICON_CLICKED, 'cartOverlayIconClicked'],
    [events.OFFER_CODE_SUCCEDED, 'fetchedCart'],
    [events.OFFER_CODE_FAILED, 'fetchedCart']
];
export const commands = [[serviceCommands.CART_OVERLAY_SHOW, 'showCartOverlay']];

export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
                onEvents.forEach(ServiceManager.setDecoratorOnFunction(on));
                commands.forEach(ServiceManager.setDecoratorOnFunction(commandProvider));
            }
        }, 50);
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
    ServiceBusControllerBody;
